'use es6';

export const ACCOUNT_SETUP_STEPS = {
  CREATE_ACCOUNT: 'createAccount',
  SETUP_BILLING: 'setupBilling',
  SETUP_COMPLETE: 'setupComplete'
};
export const ACCOUNT_SETUP_ORDER = [ACCOUNT_SETUP_STEPS.CREATE_ACCOUNT, ACCOUNT_SETUP_STEPS.SETUP_BILLING, ACCOUNT_SETUP_STEPS.SETUP_COMPLETE];
export const ACCOUNT_SETUP_STEPS_TO_DISPLAY = [ACCOUNT_SETUP_STEPS.CREATE_ACCOUNT, ACCOUNT_SETUP_STEPS.SETUP_BILLING];